import {LocalStorage} from '@/globals/LocalStorageGlobal'
import {archiveDocumentsOpener} from "@/store/archiveDocumentsOpener";
import {credit} from "@/store/modules/credit";
import {customerService} from "@/store/modules/customerService";
import {entitlement} from "@/store/modules/entitlement";
import {fund} from "@/store/modules/fund";
import {loanConfiguration} from "@/store/modules/loanConfiguration";
import {loans} from "@/store/modules/loans";
import {messagesAndLetters} from "@/store/modules/messagesAndLetters";
import Vue from 'vue'
import Vuex, {StoreOptions} from 'vuex'
import VuexPersistence from 'vuex-persist'
import {actions} from './actions'
import {getters} from './getters'
import {authentication} from './modules/authentication'
import {authorization} from './modules/authorization'
import {documents} from './modules/documents'
import {lobby} from './modules/lobby'
import {members} from './modules/members'
import {processes} from './modules/processes'
import {processesManagement} from "./modules/processesManagement";
import {search} from './modules/search'
import {mutations} from './mutations'

Vue.use(Vuex)

export interface RootState {
    idleVue: any
}

export const rootState: RootState = {
    idleVue: {} as any
}

const vuexLocal = new VuexPersistence({
    key: LocalStorage.VUEX_PERSIST,
    storage: window.localStorage,
    supportCircular: true,
    reducer: (state: any) => ({
        authentication: state.authentication,
        authorization: state.authorization,
        search: state.search,
        members: state.mainUser,
        documents: state.documents,
        processes: state.processes,
        idleVue: state.idleVue,
        credit: state.credit,
        loans: state.loans,
        entitlement: state.entitlement,
        loanConfiguration: state.loanConfiguration,
        processesManagement: state.processesManagement,
        archiveDocumentsOpener: state.archiveDocumentsOpener,
        messagesAndLetters: state.messagesAndLetters,
        customerService: state.customerService,
        fund: state.fund
    })
})

const store: StoreOptions<RootState> = {
    state: rootState,
    actions,
    getters,
    mutations,
    modules: {
        authentication,
        authorization,
        lobby,
        search,
        members,
        documents,
        processes,
        credit,
        loans,
        entitlement,
        loanConfiguration,
        processesManagement,
        archiveDocumentsOpener,
        messagesAndLetters,
        customerService,
        fund
    },
    plugins: [vuexLocal.plugin]
}

export default new Vuex.Store<RootState>(
    store
)
